// extracted by mini-css-extract-plugin
module.exports = {"userInfoDiv":"users_userInfoDiv__bbnMR","UserInfoSubHed":"users_UserInfoSubHed__fVMlx","subHed":"users_subHed__jPVP5","hed":"users_hed__rz1jX"};